module.exports = __webpack_public_path__ + "img/grey-clouds.5e19fd12.svg";